/** Aligns client-side picker filtering with inbox / task upload validation (documents use WhatsApp-style list). */

const DOCUMENT_MIME_TYPES = [
  "application/pdf",
  "application/msword",
  "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
  "application/vnd.ms-powerpoint",
  "application/vnd.openxmlformats-officedocument.presentationml.presentation",
  "application/vnd.ms-excel",
  "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  "text/plain",
];

/** @returns {"image"|"video"|"audio"|"document"|null} */
export function classifyTaskChatComposerFile(file) {
  if (!file) return null;
  const t = String(file.type || "").toLowerCase();
  const name = String(file.name || "").toLowerCase();

  if (["image/png", "image/jpeg", "image/jpg"].includes(t)) return "image";
  if (/\.(png|jpe?g)$/i.test(name)) return "image";

  if (t === "video/mp4" || t === "video/quicktime") return "video";
  if (t.startsWith("video/")) return "video";
  if (/\.(mp4|mov)$/i.test(name)) return "video";

  if (t.startsWith("audio/")) return "audio";

  if (DOCUMENT_MIME_TYPES.includes(t)) return "document";
  if (/\.(pdf|doc|docx|ppt|pptx|xls|xlsx|txt)$/i.test(name)) return "document";

  return null;
}

export function taskChatComposerFileAccept() {
  return [
    "image/png",
    "image/jpeg",
    "image/jpg",
    "video/mp4",
    "video/quicktime",
    "audio/*",
    ...DOCUMENT_MIME_TYPES,
  ].join(",");
}
